import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitEditPage } from './housing-unit-edit';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HousingUnitEditPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitEditPage),
	],
})
export class HousingUnitEditPageModule {}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-edit/housing-unit-edit.module.ts